var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('h1',[_vm._v(" "+_vm._s(_vm.session.activity.title || "Activité de répartition")+" ")]),_c('GroupSessionLayout',{attrs:{"session-id":_vm.sessionId}},[(_vm.$route.path.match('assignment'))?_c('AssignmentTask',{attrs:{"session-id":_vm.sessionId}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }